<script setup lang="ts">
import { defineProps, inject, isRef, Ref } from 'vue'

const props = defineProps<{
  labelText: string
  value: string
}>()

const selectedCheckbox = inject<string | Ref<string> | undefined>('selectedCheckbox')

function toggleSelection() {
  if (isRef(selectedCheckbox)) {
    if (selectedCheckbox.value === props.value) {
      selectedCheckbox.value = ''
    } else {
      selectedCheckbox.value = props.value
    }
  } else if (typeof selectedCheckbox === 'string') {
    if (selectedCheckbox === props.value) {
      // selectedCheckbox é string, não pode ser atualizado diretamente
    }
  }
}

function isSelected() {
  if (isRef(selectedCheckbox)) {
    return selectedCheckbox.value === props.value && '!border-4'
  }
  return selectedCheckbox === props.value && '!border-4'
}

function isSelectedWithoutBorder() {
  if (isRef(selectedCheckbox)) {
    return selectedCheckbox.value === props.value
  }
  return selectedCheckbox === props.value
}
</script>

<template>
  <div>
    <label class="flex cursor-pointer select-none items-center">
      <div class="relative">
        <input type="checkbox" class="sr-only" :checked="isSelectedWithoutBorder()" @change="toggleSelection" />
        <div :class="isSelected()" class="box mr-2 flex h-5 w-5 items-center justify-center border border-blue"></div>
      </div>
      <span class="font-medium text-black">{{ labelText }}</span>
    </label>
  </div>
</template>
